<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2023-09-07 14:02:39
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-08-08 16:04:55
 * @FilePath: \front\src\views\System\sms\smsSend.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">发送记录</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span>短信用量查询</span>|
					<span class="active">发送记录</span>
				</div>
			</div>
		</div>
		<div class="collapse-wrap">
			<CountTitle :data="this.smsCount" v-if="smsFlag" />
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>发送时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<label>手机号
							<el-input size="small" placeholder="手机号" clearable v-model="filter.phone"
								@change="handleFilter(1, $event)"></el-input>
						</label>
						<div style="display: inline-block;">短信类型
							<el-select size="small" filterable clearable v-model="filter.smsType" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option label="随访服务" value="1"></el-option>
								<el-option label="复诊提醒" value="2"></el-option>
								<el-option v-if="hospitalCode=='SD_LY1'" label="系统通知" value="3"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column prop="phone" label="手机号" width="160"></el-table-column>
					<el-table-column prop="smsContent" label="短信内容"></el-table-column>
					<el-table-column prop="smsStateStr" label="发送状态">
						<template slot-scope="scope">
							<span v-if="scope.row.smsState === 1" style="color: #67c23a;">{{scope.row.smsStateStr}}</span>
							<span v-else-if="scope.row.smsState === 2"
								style="color: #ff0000;">{{scope.row.smsStateStr}}</span>
							<span v-else style="color: #999;">{{scope.row.smsStateStr}}</span>
						</template>
					</el-table-column>
					<el-table-column width="100" prop="smsCount" label="计费条数">
					</el-table-column>
					<el-table-column prop="smsTypeStr" label="短信类型"></el-table-column>
					<el-table-column prop="createTime" label="发送时间">
					</el-table-column>
					<el-table-column prop="creatorName" label="发送人"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';
	import CountTitle from '../components/countTitle.vue';

	export default {
		mixins: [mixin],
		components: {
			CountTitle
		},

		data() {
			return {
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null,
					summary: []
				},
				filter: {
					phone: '',
					pageNumber: 1,
					pageSize: 10,
					sendTimeEnd: '',
					sendTimeStart: '',
					smsType: ''
				},				
				smsCount: {},
				smsFlag: false,
				hospitalCode:''
			}
		},
		created() {
			this.loadList();
		},
		methods: {
			async loadList() {
				this.isLoading = true;
				this.hospitalCode=await api.getHospitalCode();
				this.smsFlag = await api.getSmsFlag();
				if (this.smsFlag) {
					// 如果使用双佰康短信
					let r = await api.getSmsCountList(this.filter);
					this.smsCount = r.data;
				}
				let res = await api.getSmsSendList(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				this.list.data = res.data;
				this.isLoading = false;
			},
			// 过滤条件 更改
			handleFilter(key, val) {
				switch (key) {
					case 0:
						if (this.filter.date) {
							this.filter.sendTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.sendTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.sendTimeStart = '';
							this.filter.sendTimeEnd = '';
						}
						break;
				}
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';

	/deep/.search-bar .el-select .el-input {
		width: 140px
	}

	/deep/.el-form .el-input {
		width: 180px
	}

	ul {
		border-bottom: 1px solid rgba(227, 227, 227, 0.5);
	}

	.collapse-wrap .search-bar {
		padding: 0 0 25px;
		box-shadow: none;
	}

	.collapse-wrap .def-key {
		padding: 20px 20px 0;
	}

	.collapse-wrap .table-wrap {
		margin-right: 0;
		padding: 0 20px 20px;
	}
</style>